import { render, staticRenderFns } from "./VecDynPublicationInfoEdit.vue?vue&type=template&id=16c90927&scoped=true&"
import script from "./VecDynPublicationInfoEdit.vue?vue&type=script&lang=js&"
export * from "./VecDynPublicationInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./VecDynPublicationInfoEdit.vue?vue&type=style&index=0&id=16c90927&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c90927",
  null
  
)

export default component.exports